var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicPoemas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEF3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDE68A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scrollGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDF4E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quillGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D97706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#92400E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 32)",
    filter: "drop-shadow(0px 3px 2px rgba(146, 64, 14, 0.2))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -16,-16               L 10,-16               C 14,-16 16,-12 16,-8               L 16,12               C 16,16 12,18 8,18               L -18,18               C -22,18 -24,14 -24,10               L -24,-10               C -24,-14 -20,-16 -16,-16 Z",
    fill: "url(#scrollGrad)",
    stroke: "#F59E0B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -16,-16 C -12,-16 -10,-14 -12,-11 C -14,-8 -18,-8 -20,-11 C -22,-14 -20,-16 -16,-16 Z",
    fill: "#F59E0B",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8,18 C 12,18 14,16 12,13 C 10,10 6,10 4,13 C 2,16 4,18 8,18 Z",
    fill: "#F59E0B",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -14,-8 C -10,-8 -10,-10 -6,-10 M -12,-4 C -8,-4 -8,-6 -4,-6 M -14,0 C -10,0 -10,-2 -6,-2 M -12,4 C -8,4 -8,2 -4,2",
    fill: "none",
    stroke: "#78350F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 0) rotate(-35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -12,15 L -9,11 L -7,12 Z",
    fill: "#78350F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -9,11 L 12,-18",
    fill: "none",
    stroke: "#92400E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -7,10                 C -1,6 4,-1 11,-12                 C 12,-14 9,-16 8,-16                 C 1,-8 -5,-2 -9,7",
    fill: "url(#quillGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4,-2 L 7,-3 M 0,3 L 3,2",
    stroke: "#FEF3C7",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicPoemas);
export default __webpack_public_path__ + "static/media/topic_poemas.6c3b0b12499aa9f9be6da52d5daf2973.svg";
export { ForwardRef as ReactComponent };